import {Injectable} from '@angular/core';
import {CustomFieldsService as CustomFieldsApiService} from '../../api/services/custom-fields.service';
import {CustomFieldModel} from '../../api/models/custom-field-model';
import {LookupModel} from '../../api/models/lookup-model';

@Injectable()
export class CustomFieldsService {

  customFieldCategories: LookupModel[] = [
    {intId: 0, id: '0', text: 'Contacts'}
  ];

  customFieldTypes: LookupModel[] = [
    {id: 'text', text: 'Text'},
    {id: 'number', text: 'Number'},
    {id: 'boolean', text: 'Boolean'},
    {id: 'date', text: 'Date'},
    {id: 'list', text: 'List'},
  ];

  customFieldFormats: LookupModel[] = [
    {id: '', text: 'None'},
    {id: 'phoneNumber', text: 'Phone Number'},
  ];

  constructor(private customFieldsApiService: CustomFieldsApiService) {

  }

  public async getCustomFieldById(id: string): Promise<CustomFieldModel> {
    return await this.customFieldsApiService.customFieldsGetCustomFieldById({id: id}).toPromise();
  }

  public async saveCustomField(model: CustomFieldModel): Promise<boolean> {
    await this.customFieldsApiService.customFieldsSaveCustomField({body: model}).toPromise();

    return true;
  }

  public async deleteCustomField(id: string): Promise<boolean> {
    await this.customFieldsApiService.customFieldsDeleteCustomFieldById({id: id}).toPromise();

    return true;
  }
}
